export default "__VITE_ASSET__oPBMoutE__"